<template name="home">
  <div class="home">
    <div class="center-body" v-if="setInput">
      <form @submit.prevent="connect">
        <div class="title">애니서포트 영상지원</div>
        <div class="subtitle">
          상담원에게 안내받은<br>
          6자리 인증번호를 입력해 주세요.
        </div>
        <div class="error-message">{{$client.error}}</div>
        <input class="inputbox"
          type="number"
          pattern="[0-9]*"
          v-model="shortkey"
          placeholder="000000"
          @keydown="inputFilter"
        />
        <button class="submit-button" type="submit">영상지원 시작</button>
      </form>
    </div>
    <div class="center-body" v-else>
      <div>
        <div class="lds-ripple"><div></div><div></div></div>
        <div class="loading-message">잠시만 기다려 주세요</div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/plugin/modernizr'
export default {
  methods: {
    validateKey (key) {
      if (!key) return '인증번호를 입력해 주세요';
      if (key.length !== 6) return '인증번호6자리를 입력해 주세요';
      if (!parseInt(key, 10)) return '올바른 인증번호를 입력해 주세요';
      return null
    },
    inputFilter (ev) {
      if (/[0-9]/.test(ev.key) && this.shortkey.length === 6) {
        ev.preventDefault()
      }
    },
    connect () {
      //2020.04.07 테스트
      let ret = this.validateKey(this.shortkey)
      if (ret) return this.$client.error = ret
      this.$client.error = ''
      this.setInput = false
      this.$client.connect(this.shortkey)
      //this.$router.replace({name: 'video-chat', params: { fromHome: true}})
      this.$router.replace({name: 'video-chat', params: { fromHome: true, shortkey: this.shortkey }})

      // if (!/SamsungBrowser/i.test(navigator.userAgent)) {
      //   if (document.body.requestFullscreen) document.body.requestFullscreen()
      //   else if (document.body.webkitRequestFullscreen) document.body.webkitRequestFullscreen()
      // }
      
    }
  },
  created () {
    // if (!Modernizr.datachannel
    //  || !Modernizr.getusermedia
    //  || !Modernizr.peerconnection
    //  || !Modernizr.websockets) {
    //    this.$router.replace({name: 'error', params: {type: 'not-support-rtc'} })
    // }
    // this.$router.replace({name: 'error-not-support', params: {type: 'not-support-rtc'} })
    // navigator.geolocation.getCurrentPosition(position => (this.$client.geolocation = position))
   
  },
  mounted () {
    if (this.$route.query.c) {
      let ret = this.validateKey(this.$route.query.c)
      if (ret) {
        this.$client.error = ret
        this.setInput = true
        return;
      }
      this.shortkey = this.$route.query.c
      this.$client.connect(this.$route.query.c)

      // if (document.body.requestFullscreen) document.body.requestFullscreen()
      // else if (document.body.webkitRequestFullscreen) document.body.webkitRequestFullscreen()
    }
    else {
      this.setInput = true
    }
  },
  data () {
    return {
      shortkey: '',
      setInput: false,
      angle: 0
    }
  }
}

// Not showing vendor prefixes or code that works cross-browser.
  /*var errorCallback = function(e) {
    alert(e);
  };

  navigator.getUserMedia({video: true, audio: true}, function(stream) {
    var video = document.querySelector('video');
    var audio = document.querySelector('audio');
    //video.src = window.URL.createObjectURL(localMediaStream);

    video.src = window.URL.createObjectURL(stream);
    localMediaStream = stream;
  }, errorCallback);*/

</script>

<style lang="scss" scoped>
  .header {
    position: absolute;
    top: 10px; left: 10px;
  }

  .title {
    color: #00284c;
    font-weight: bold;
    font-size: 22px;
  }
  .subtitle {
    text-align: center;
    font-size: 16px;
    margin: 16px 0 0px;
  }

  .home {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-image: url(../assets/bgimg.png);
    background-position: center center;
    background-size: cover;
  }

  .center-body {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
  }

  .error-message {
    color: #ff0000;
    line-height: 36px;
    margin-bottom: 20px;
  }

  .inputbox {
    display: block;
    width: 100%; max-width: 280px; height: 50px;
    padding: 0;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    border-radius: 4px;
    color: #00a0e9;
    border: 1px solid #d9d9d9;
    background-color: white;
    box-sizing: border-box;
    letter-spacing: 0.4em;
    margin: 0 auto 4px;
    outline: none;
    -webkit-appearance: none;
    &::placeholder {
      color: #CCCCCC;
    }
  }

  .submit-button {
    width: 100%; max-width: 280px; height: 50px;
    border-radius: 4px;
    border: 1px solid #00a0e9;
    box-sizing: border-box;
    background-color: #00a0e9;
    color: #ffffff;
    font-size: 16px;
    display: block;
    margin: 0 auto;
  }
</style>
